import React from 'react'
import './NavigationWithSideBar.scss'

export interface NavigationSidebarSection {
  id: string
  label: string
  disabled?: boolean
}

export interface NavigationSidebarProps {
  sections: NavigationSidebarSection[]
  activeSection: string
  onSectionClick: (id: string) => void
}

export const NavigationSidebar: React.FC<NavigationSidebarProps> = ({
  sections,
  activeSection,
  onSectionClick,
}: {
  sections: NavigationSidebarSection[]
  activeSection: string
  onSectionClick: (id: string) => void
}) => {
  return (
    <nav className='scroll-navigation__sidebar'>
      <ul className='list-unstyled mb-0'>
        {sections.map((section) => (
          <li key={section.id} className='mb-2'>
            <button
              disabled={section.disabled || false}
              type='button'
              onClick={() => onSectionClick(section.id)}
              className={`btn w-100 text-start rounded-0 scroll-navigation__nav-button ${
                activeSection === section.id ? 'scroll-navigation__nav-button--active' : 'scroll-navigation__nav-button--inactive'
              }`}
            >
              <span className='zocks-text-gray-900'>{section.label}</span>
            </button>
          </li>
        ))}
      </ul>
    </nav>
  )
}
